'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactSlick = require('react-slick');

var _reactSlick2 = _interopRequireDefault(_reactSlick);

var _MiniListing = require('../shared/MiniListing');

var _MiniListing2 = _interopRequireDefault(_MiniListing);

var _trackClick = require('../HOCs/trackClick');

var _trackClick2 = _interopRequireDefault(_trackClick);

var _utils = require('../utils');

var _Arrow = require('./Arrow');

var _Arrow2 = _interopRequireDefault(_Arrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppCategory = function (_Component) {
  _inherits(AppCategory, _Component);

  function AppCategory(props) {
    _classCallCheck(this, AppCategory);

    var _this = _possibleConstructorReturn(this, (AppCategory.__proto__ || Object.getPrototypeOf(AppCategory)).call(this, props));

    _this.renderListings = function () {

      var sliderFeaturesVisibility = _this.getSliderVisibility();
      var variableMargins = sliderFeaturesVisibility ? '' : 'no-side-margins';

      var sliderSettings = {
        dots: true,
        infinite: false,
        speed: 500,
        lazyLoad: false,
        responsive: [{
          breakpoint: 530,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 980,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4
          }
        }, {
          breakpoint: 1200,
          settings: {
            slidesToShow: 5,
            slidesToScroll: 5
          }
        }, {
          breakpoint: 10000,
          settings: {
            slidesToShow: 6,
            slidesToScroll: 6
          }
        }],
        className: 'slider-row ' + variableMargins,
        dotsClass: '' + (sliderFeaturesVisibility ? 'ac-listings-slider-dots' : 'hidden'),
        draggable: true

      };

      return _react2.default.createElement(
        'div',
        { className: 'collection-row' },
        _react2.default.createElement(
          _reactSlick2.default,
          sliderSettings,
          _this.props.listings.map(function (listing, i) {
            var TrackedListing = (0, _trackClick2.default)(_react2.default.createElement(_MiniListing2.default, {
              listing: listing,
              isLoggedIn: _this.props.isLoggedIn
            }), 'CLICK', {
              context: 'HOME',
              type: 'LISTING',
              v2_listing_id: listing.ID,
              app_name: listing.core.listingName,
              domain: window.location.hostname
            });
            var listingLink = (0, _utils.getAppCenterPathName)(_this.props.location.pathname) + '/listings/' + listing.ID;
            return _react2.default.createElement(
              _reactRouter.Link,
              {
                key: i,
                to: listingLink,
                'data-analytics': 'ec=' + listing.localized.name + '\n                |ea=ViewDetails\n                |dp=Home\n                |dt=AppCenterHome\n                |cd2=nui',
                onClick: function onClick() {
                  return document.title = _this.context.getTitle(listing.localized.name);
                }
              },
              _react2.default.createElement(TrackedListing, { style: { display: 'inline-block' } })
            );
          })
        )
      );
    };

    _this.state = { width: 0, height: 0 };
    _this.updateWindowDimensions = _this.updateWindowDimensions.bind(_this);
    return _this;
  }

  _createClass(AppCategory, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.updateWindowDimensions();
      window.addEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateWindowDimensions);
    }
  }, {
    key: 'updateWindowDimensions',
    value: function updateWindowDimensions() {
      this.setState({ width: window.innerWidth, height: window.innerHeight });
    }
  }, {
    key: 'getSliderVisibility',
    value: function getSliderVisibility() {
      var sliderFeaturesVisibility = false;

      if (this.props.listings.length > 6 && this.state.width > 1200) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 5 && this.state.width > 980 && this.state.width <= 1200) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 4 && this.state.width > 768 && this.state.width <= 980) {
        sliderFeaturesVisibility = true;
      } else if (this.props.listings.length > 2 && this.state.width <= 768) {
        sliderFeaturesVisibility = true;
      }

      return sliderFeaturesVisibility;
    }
  }, {
    key: 'renderArrow',
    value: function renderArrow(prevNext, isVisible) {
      return _react2.default.createElement(_Arrow2.default, { direction: prevNext, areSlideFeaturesVisible: isVisible ? '' : 'hidden' });
    }
  }, {
    key: 'render',
    value: function render() {

      if (this.props.listings.length === 0) return null;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: 'row' },
          _react2.default.createElement(
            'div',
            { className: 'col-sm-12' },
            _react2.default.createElement(
              'h2',
              { className: 'collection-title' },
              this.props.categoryTitle
            ),
            _react2.default.createElement(
              'p',
              { className: 'collection-description' },
              this.props.categorySubtitle
            )
          )
        ),
        this.renderListings()
      );
    }
  }]);

  return AppCategory;
}(_react.Component);

AppCategory.propTypes = {
  categoryTitle: _propTypes2.default.any.isRequired,
  categorySubtitle: _propTypes2.default.any.isRequired,
  listings: _propTypes2.default.array.isRequired,
  isLoggedIn: _propTypes2.default.bool.isRequired,
  location: _propTypes2.default.object
};

AppCategory.contextTypes = {
  getTitle: _propTypes2.default.func
};

exports.default = (0, _reactRouter.withRouter)(AppCategory);


//////////////////
// WEBPACK FOOTER
// ./lib/listings/AppCategory.js
// module id = 569
// module chunks = 0